import { QuoteApiModel } from '~/lib/api/smartsend/types';
import { SmartSendProvider } from '~/lib/consts/providers';
import { QuoteTagType } from './QuoteTagType';

export interface QuoteFilter {
  Search: string;
  ServiceType: 'Collection' | 'Shop' | 'All';
  SubCategory: string;
  Product: string;
  Tags: string[];
  MatchAllTags: boolean;
}

const FilterQuotes = (quotes: QuoteApiModel[], filter: QuoteFilter, quoteTagType: QuoteTagType) => {
  if (!(filter && quotes)) {
    return [];
  }

  return quotes
    .filter((x) => {
      if (filter.ServiceType === 'All') {
        return true;
      }

      if (filter.ServiceType === 'Shop') {
        return x.Service.CollectionType === 'Locker' || x.Service.CollectionType === 'Shop';
      }

      return x.Service.CollectionType === filter.ServiceType;
    })
    .filter(
      (x) =>
        !filter.SubCategory ||
        filter.SubCategory === SmartSendProvider ||
        filter.SubCategory == quoteTagType ||
        (filter.SubCategory === `${SmartSendProvider}-BUSINESS` && x.Service.Id.toLowerCase().indexOf('business') > -1)
    )
    .filter((x) => !filter.Product || x.Service.CourierProductName === filter.Product)
    .filter(
      (x) =>
        !filter.Search ||
        x.Service.Name.toLowerCase().indexOf(filter.Search.toLowerCase()) > -1 ||
        !!x.Service.Tags?.find((t) => t.toLowerCase().indexOf(filter.Search.toLowerCase()) > -1) ||
        x.Service.CourierName.toLowerCase().indexOf(filter.Search.toLowerCase()) > -1 ||
        x.Service.CourierProductCode?.toLowerCase().indexOf(filter.Search.toLowerCase()) > -1 ||
        x.Service.CourierProductName?.toLowerCase().indexOf(filter.Search.toLowerCase()) > -1
    )
    .filter(
      (x) =>
        !filter.Tags ||
        filter.Tags.length === 0 ||
        (filter.MatchAllTags
          ? filter.Tags.length == filter.Tags.filter((ft) => x.Service.Tags.includes(ft)).length
          : !!x.Service.Tags.find((st) => filter.Tags.includes(st)))
    )
    .sort((a, b) => a.Options[0].TotalPrice - b.Options[0].TotalPrice);
};
export default FilterQuotes;
